import { Body, Heading, VStack } from '@hover/blueprint';
import React from 'react';

import {
  TranslationNamespace,
  useQueryParam,
  useTranslate,
} from 'src/shared/hooks';
import { useIsMobileSize } from 'src/shared/hooks/useIsMobileSize';
import { useEmbedContext } from 'src/shared/providers/Embed';

export const EmbedHeader = () => {
  const t = useTranslate(TranslationNamespace.SHARED);
  const isMobile = useIsMobileSize();
  const isCarouselEnabled = useQueryParam('showCarousel') === 'true';

  const { header, subheader } = useEmbedContext();

  return (
    <VStack
      marginTop={{ base: 400, tablet: 700 }}
      mb={isCarouselEnabled ? { base: 200, tablet: 400 } : undefined}
    >
      <Heading
        color="text.primaryInvert"
        size={{ base: 'medium', tablet: 'large' }}
        textAlign="center"
        whiteSpace="pre-line"
        width="100%"
      >
        {header ||
          (isMobile ? t('embed.addAPhotoMobile') : t('embed.addAPhoto'))}
      </Heading>
      <Body
        color="text.secondaryInvert"
        display={{ base: 'none', tablet: 'contents' }}
      >
        {subheader || t('embed.editWithEndless')}
      </Body>
    </VStack>
  );
};
